export const financeStatusConfig = {
  svcfin: {
    statusMapping: {
      Approved: 'approved',
      'Approved - Counter Offer': 'approved_short',
      Denied: 'declined',
      Declined: 'declined',
    },

    financingOutcomes: [
      'approved',
      'approved_short',
      'declined',
    ],
  },
};
